// extracted by mini-css-extract-plugin
export default {"chartTitle":"OperationalSensorChartContainer_chartTitle__5oRaf","marginTop":"OperationalSensorChartContainer_marginTop__oB4EP"};